import { TEMPLATE } from '@/shared/constants';
import { ApiService } from './ApiService';

export class StorageService {

  static async putTemplateImageFiles(files: File[]) {
    const formData = new FormData();
    formData.append('overwrite', 'replace');
    formData.append('title', '');
    files.forEach((file) => {
      formData.append('files', file);
    });

    return await ApiService.fetch<string[]>(`/api/images`, 'POST', formData);
  }

  public static async putTemplateFile(fileName: string, text: string) {
    await ApiService.fetch(`/api/template/${fileName}`, 'PUT', text);
  }

  public static async deleteTemplateFile(fileName: string) {
    await ApiService.fetch(`/api/template/${fileName}`, 'DELETE');
  }

  public static async getTemplateFile(fileName: string): Promise<string> {
    const result = await ApiService.fetch<string>(`/api/template/${fileName}`);
    return result;
  }

  public static async getTemplateList(): Promise<string[]> {
    return await ApiService.fetch(`/api/template`, 'GET');
  }

  public static async getPageFile(fileName: string): Promise<string> {
    const result = (fileName === TEMPLATE.PAGE_ABOUT)
      ? await ApiService.anonymousFetch<string>(`/api/page/${fileName}`)
      : await ApiService.fetch<string>(`/api/template/${fileName}`);
    return result;
  }

  public static async loadItems<T>(
    loader: (force?: boolean) => Promise<T[]>,
    setErrorMessage: (error: any) => void,
    setIsLoading: (loading: boolean) => void,
    force?: boolean
  ) {
      setIsLoading(true);
      setErrorMessage(undefined);
      try {
        return await loader(force);
      } catch (error) {
        setErrorMessage(error);
        return [];
      } finally {
        setIsLoading(false);
      }
  }

  /**
   * Renames a page template file on the server.
   * @param oldFileName The current file name (e.g., PAGE_OLDNAME.md)
   * @param newFileName The new file name (e.g., PAGE_NEWNAME.md)
   */
  public static async renameTemplateFile(oldFileName: string, newFileName: string) {
    await ApiService.fetch(`/api/template/${oldFileName}`, 'PATCH', { newFileName });
  }
  
}
